'use client';

import { Input, Textarea } from '@headlessui/react';

interface IContactInputProps {
  /**
   * If true, it will render a textarea instead of a input.
   */
  hasTextArea?: boolean;
  /**
   * A callback function that will be executed when the input is changed.
   */
  onChange: () => void;
  /**
   * Placeholder text of the input
   */
  placeholder: string;
}

/**
 * -----------------------------------------------------------------------------
 * It renders the input and text area element to show in the contact form, In
 * order to render the text area, the hasTextArea prop should be set to true.
 */
export function ContactInput({
  hasTextArea,
  onChange,
  placeholder,
}: Readonly<IContactInputProps>) {
  return hasTextArea ? (
    <Textarea onChange={onChange} placeholder={placeholder} rows={4} />
  ) : (
    <Input onChange={onChange} placeholder={placeholder} type="text" />
  );
}
